import { render, staticRenderFns } from "./select-labs.vue?vue&type=template&id=25c0cd30&scoped=true&"
import script from "./select-labs.vue?vue&type=script&lang=js&"
export * from "./select-labs.vue?vue&type=script&lang=js&"
import style0 from "./select-labs.vue?vue&type=style&index=0&id=25c0cd30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c0cd30",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex})
